import Results from "./Results";
import "./Results.scss";

export default Results;
